import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import NavigationMenu from './elements/NavigationMenu/NavigationMenu';
import ScrollBtn from './elements/ScrollBtn/ScrollBtn';

function App() {
  return (
    <div className="lern-app">
      <ScrollBtn />
      <BrowserRouter>
        <NavigationMenu />
      </BrowserRouter>
    </div>
  );
}

export default App;
